'use client';

import React, { useCallback, useState } from 'react';
import { ChevronDown, Menu } from 'lucide-react';
import { motion } from 'framer-motion';

interface CatalogMenuProps {
  className?: string;
  onToggle?: () => void;
  isOpen?: boolean;
  isActive?: boolean;
  isMobile?: boolean;
  label?: string;
  isLeft?: boolean;
}

export function CatalogMenu({
  className,
  onToggle,
  isOpen = false,
  isActive = false,
  isMobile = false,
  label = 'CATALOG RAISONNE',
  isLeft = false
}: CatalogMenuProps) {
  const [isHovered, setIsHovered] = useState(false);

  const handleToggle = useCallback(
    (e: React.MouseEvent) => {
      // Prevent event bubbling
      e.stopPropagation();
      e.preventDefault();
      if (onToggle) {
        onToggle();
      }
    },
    [onToggle]
  );

  // Define the strobing animation variants
  const strobingVariants = {
    initial: { filter: isActive ? 'invert(100%)' : 'invert(0%)' },
    hover: {
      filter: ['invert(0%)', 'invert(100%)', 'invert(0%)', 'invert(100%)', 'invert(0%)'],
      transition: {
        duration: 0.6,
        times: [0, 0.25, 0.5, 0.75, 1],
        ease: 'easeInOut',
      },
    },
  };

  return (
    <motion.button
      className={`nav-button inline-flex items-center ${className || ''} ${isOpen ? 'text-amber-400 bg-zinc-900' : ''}`}
      onClick={handleToggle}
      data-catalog-button
      aria-expanded={isOpen}
      onMouseEnter={() => !isOpen && setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      initial="initial"
      animate={isHovered && !isOpen ? 'hover' : 'initial'}
      variants={strobingVariants}
      style={{
        paddingInline: isMobile ? 'calc(var(--spacing)* 1)' : 'calc(var(--spacing)* 2)',
      }}
    >
      {!isMobile && (
        <div className={'inline-flex items-center gap-1' + (isLeft ? ' flex-row-reverse' : '')}>
          <span>{label}</span>
          <ChevronDown
            size={14}
            className={`transition-transform duration-300 ease-in-out ${isOpen ? 'rotate-180' : ''}`}
          />
        </div>
      )}
      {isMobile && (
        <>
          <Menu size={14} className={`transition-transform duration-300 ease-in-out ${isOpen ? 'rotate-180' : ''}`} />
        </>
      )}
    </motion.button>
  );
}
